// @flow

export default {};

export type AuthZInfo = {|
  canBoostContent?: boolean,
|};

export { default as WithAuthzInfo } from './WithAuthzInfo';
export { default as AuthZInfoQuery } from './AuthZInfo.gql';
